import { captureEvent } from "@/lib/posthog"

export default function GuestActionBar({
  onSave,
  onClear,
  hasContent,
}: {
  onSave: () => void
  onClear: () => void
  hasContent: boolean
}) {
  return (
    <div className="flex items-center gap-3">
      {hasContent && (
        <button
          onClick={onClear}
          className="text-sm text-gray-500 hover:text-gray-700"
        >
          Clear
        </button>
      )}
      <button
        onClick={() => {
          captureEvent("guest_save_clicked", { has_content: hasContent })
          onSave()
        }}
        disabled={!hasContent}
        className="rounded-lg bg-chessdrop-600 px-4 py-2 text-sm font-medium text-white hover:bg-chessdrop-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Save
      </button>
    </div>
  )
}
